 
import Navbarsection from "../views/Home/Navbarsection" 
  
import Footersection from "../views/Home/Footersection"
import Contactsection from "../views/Home/Contactsection"
   
export default function Contact() {
  return (
<>
 
<Navbarsection />
 
 <Contactsection/>
 
<Footersection />
 
  
  
</>
  )
}
